import { memo, useMemo } from "react";
import PropTypes from "prop-types";

import { Box, Typography, useTheme } from "@mui/material";

const FGStatusChip = ({ label, tone = "neutral" }) => {
  const theme = useTheme();

  const tones = useMemo(
    () => ({
      warning: {
        bg: theme.palette.orange.light,
        color: theme.palette.orange.dark,
        border: theme.palette.orange.dark,
      },
      success: {
        bg: theme.palette.green.light,
        color: theme.palette.green.dark,
        border: theme.palette.green.dark,
      },
      danger: {
        bg: theme.palette.error.errorBgColor,
        color: theme.palette.error.dark,
        border: theme.palette.error.dark,
      },
      neutral: {
        bg: theme.palette.grey[100],
        color: theme.palette.text.secondary,
        border: theme.palette.grey[300],
      },
    }),
    [theme],
  );

  const selectedTone = tones[tone] || tones.neutral;

  return (
    <Box
      px={1.7}
      py={0.55}
      borderRadius={999}
      sx={{
        backgroundColor: selectedTone.bg,
        border: "1px solid",
        borderColor: selectedTone.border,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        whiteSpace: "nowrap",
        minHeight: 32,
        width: "fit-content",
        maxWidth: "100%",
      }}
    >
      <Typography
        variant="body2"
        fontWeight={700}
        sx={{
          color: selectedTone.color,
          lineHeight: 1.2,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

FGStatusChip.propTypes = {
  label: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(["warning", "success", "danger", "neutral"]),
};

export default memo(FGStatusChip);
